"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.S7Corp = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var S7Corp = function S7Corp(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 120,
    height: 48,
    viewBox: "0 0 120 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S7Corp_svg__S7Corp_svg__clip0_29042_58739)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "S7Corp_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 124,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.2-1.125h122.4v50.25H-1.2v-50.25z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#S7Corp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.003 24.333c-.407 5.214-4.04 8.522-9.391 8.522-6.043 0-10.051-4.34-10.051-10.926 0-6.429 4.195-10.893 10.237-10.893 4.884 0 8.704 3.152 9.047 7.491H71.34c-.47-2.34-2.16-3.683-4.635-3.683-3.38 0-5.541 2.778-5.541 7.148 0 4.339 2.129 7.086 5.51 7.086 2.724 0 4.382-1.622 4.76-4.745h4.57zm4.849.5c0 3.06 1.377 4.869 3.695 4.869 2.286 0 3.63-1.81 3.63-4.9 0-3.029-1.378-4.87-3.63-4.87-2.348 0-3.695 1.81-3.695 4.9zm11.49-.031c0 4.807-3.1 7.96-7.795 7.96-4.728 0-7.859-3.185-7.859-7.93 0-4.806 3.162-7.959 7.984-7.959 4.57 0 7.67 3.184 7.67 7.929zm11.272-3.965c-.75-.124-1.158-.156-1.627-.156-1.472 0-2.694.687-3.382 1.873-.47.749-.627 1.717-.627 3.497v6.305h-4.13V17.28h3.943v2.779c1.096-2.093 2.693-3.091 4.885-3.091.311 0 .5 0 .938.062v3.808zm4.988 4.059c0 2.933 1.377 4.65 3.665 4.65 2.223 0 3.569-1.748 3.569-4.588 0-2.904-1.346-4.714-3.569-4.714-2.317 0-3.665 1.686-3.665 4.652zm-.03-5.745c1.065-1.529 2.631-2.279 4.695-2.279 4.039 0 6.733 3.217 6.733 8.024 0 4.745-2.599 7.866-6.575 7.866-2.036 0-3.507-.718-4.666-2.279v7.211h-4.131V17.278h3.944v1.873z",
    fill: "#5E6060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.144 24.004C48.144 37.264 37.374 48 24.08 48 10.782 48 0 37.264 0 24.004 0 10.746 10.782 0 24.08 0c13.293 0 24.064 10.746 24.064 24.004z",
    fill: "#00A1AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.323 11.478c-3.788 0-6.247.209-8.03.867-2.99 1.163-5.057 3.599-5.057 6.799 0 2.666 1.244 4.597 4.847 6.818 3.846 2.324 4.61 3.09 4.61 4.491 0 1.532-1.506 3.278-5.38 3.278-1.352 0-3.388-.188-4.69-.505l-.622-.156c-.346.925-1.13 3.118-1.37 3.913l.613.179c1.17.372 3.95.664 5.94.664 6.623 0 10.573-3.99 10.573-8.167 0-2.568-1.169-4.518-5.118-6.977-1.983-1.216-2.992-2.002-3.603-2.614-.497-.636-.554-1.11-.554-1.611 0-.478.107-1.027.423-1.432.344-.5.969-.817 1.817-1.078.871-.288 2.489-.297 5.008-.297h2.342l1.673-4.172h-3.422zm17.716 0H28.26l-1.675 4.172h3.906c2.626 0 3.131-.057 3.79-.057-.952 2.172-6.692 16.756-6.692 16.756h4.858s7.268-18.153 8.037-20.057c.212-.425.109-.814-.445-.814z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "S7Corp_svg__S7Corp_svg__clip0_29042_58739"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v48H0z"
  }))));
};

exports.S7Corp = S7Corp;
var _default = S7Corp;
exports.default = _default;